<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <applicant-form [form]="contactDataProcessStepForm"></applicant-form>
</form-layout>
